import { api } from './instances';

const getPaths = requestBody => api.post('/paths', requestBody).then(response => response.data);

export { getPaths };
